import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { $motnItem } from './model'

const skin = era.skin('routes/motn/details')

export function Title(): JSX.Element {
  const motnItem = useUnit($motnItem)
  return <AppTitle>{motnItem?.name || 'Content'}</AppTitle>
}

MotnDetailsPage.displayName = 'MotnDetailsPage'
export function MotnDetailsPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='content-details-page'>
        <ui.RenderSkin name='motnBanner' />
        <ui.RenderSkin name='motnContent' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
